import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
const Beverage = props => (
  <SvgIcon {...props}>
    <defs>
       <path d="M11.50759,8.38669318 L12.1437717,2.02487593 C12.1450124,1.86192881 12.0330836,1.75 11.8950124,1.75 L2.10498756,1.75 C1.94272567,1.7649793 1.84248967,1.88748996 1.85622826,2.02487593 L2.4437088,7.89968125 C4.32194138,6.96686142 5.61598595,7.09446748 7.3354102,7.95417961 C7.46318368,8.01835028 7.46318368,8.01835028 7.58814885,8.08148009 C9.09049707,8.83930176 9.92942097,8.98004832 11.50759,8.38669318 Z M2.10498756,0.25 L11.8950124,0.25 C12.8615108,0.25 13.6450124,1.03350169 13.6450124,2 C13.6450124,2.05815208 13.6421139,2.11626802 13.6363275,2.17413151 L11.8363275,20.1741315 C11.7468672,21.0687347 10.9940775,21.75 10.0950124,21.75 L3.90498756,21.75 C3.00592253,21.75 2.25313279,21.0687347 2.16367248,20.1741315 L0.363672479,2.17413151 C0.267502303,1.21242974 0.969154289,0.354855094 1.93085605,0.258684917 C1.98871954,0.252898569 2.04683548,0.25 2.10498756,0.25 Z" id="beverage-path-1" />
     </defs>
    <g id="Icon/Product/Beverage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
       <g transform="translate(5.000000, 1.000000)">
        <mask id="beverage-mask-2" fill="white">
            <use xlinkHref="#beverage-path-1" />
          </mask>
        <use id="Mask" fill={props.color} fillRule="nonzero" xlinkHref="#beverage-path-1" />
        <g mask="url(#beverage-mask-2)" fill={props.color}>
            <g transform="translate(-5.000000, -1.000000)" id="Rectangle">
                <rect x="0" y="0" width="24" height="24" />
              </g>
          </g>
      </g>
     </g>
  </SvgIcon>
);

export default Beverage;



// WEBPACK FOOTER //
// ./src/icons/types/Beverage.jsx